import { useEffect, useState } from 'react';

/**
 * false hasta que el elemento entra a la pantalla (o se acerca, con `margen`); desde entonces, true para siempre.
 * Sirve para hacer algo una sola vez cuando alguien llega a una sección (p. ej. descargar de antemano).
 * @param {import('react').RefObject<HTMLElement>} ref
 * @param {string} [margen]  rootMargin del IntersectionObserver
 * @returns {boolean}
 */
export default function useVisto(ref, margen = '200px 0px') {
  const [visto, setVisto] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || visto || typeof IntersectionObserver !== 'function') return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      setVisto(true);
      io.disconnect();
    }, { rootMargin: margen });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, margen, visto]);
  return visto;
}
